import type { MediaSessionConfig } from '@yandex-360/telemost-sdk/device-manager';
import type { SessionConfig, SessionConfigFlags } from '@yandex-video-platform/goloom-sdk';

import { mapSoundProcessorToGoloom } from './goloom-sound-processor-mappers';
import { mapVideoProcessorToGoloom } from './goloom-video-processor-mappers';

const mapSessionConfigFlagsToGoloom = (flags: MediaSessionConfig['flags']): Maybe<SessionConfigFlags> => {
    if (!flags) {
        return undefined;
    }

    const result: Record<string, boolean> = {};

    for (const [key, value] of Object.entries(flags)) {
        if (typeof value === 'boolean') {
            result[key] = value;
        }
    }

    return Object.keys(result).length > 0 ? toGoloomSessionConfigFlags(result) : undefined;
};

const toGoloomSessionConfigFlags = (flags: Record<string, boolean>): SessionConfigFlags => {
    // Goloom typings list known flags, but runtime config supports experiment flags too.
    return flags as SessionConfigFlags;
};

export const mapSessionConfigToGoloom = (config: MediaSessionConfig): SessionConfig => ({
    soundProcessing: config.soundProcessing ? mapSoundProcessorToGoloom(config.soundProcessing) : undefined,
    videoProcessing: config.videoProcessing ? mapVideoProcessorToGoloom(config.videoProcessing) : undefined,
    flags: mapSessionConfigFlagsToGoloom(config.flags),
});
